import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseDateMonth extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseDateMonth {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseDateMonth;

  public mode() {
    return TEDParseDateTimeMode.pdmYM;
  }
}
